<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Download Reports</a>
  </div>
  <div class="container">
    <!-- Change Transit Time Active Versions Form-->
    <form [formGroup]="changeTransitTimeActiveVersionForm" [hidden]="loading" class="pure-form pure-form-stacked" (ngSubmit)="render()">

      <!-- Select option for From Country Code Options -->
      <div class="pure-control-group">
        <label for="fromCountryCodeId">From Country Code <app-popover [message]="help_messages.from_country_code"></app-popover></label>
        <select id="fromCountryCodeId" class="pure-input-2-3"
                formControlName="fromCountryCode" #fromCountryCode (change)="onFromCountryCodeChange(fromCountryCode.value)">
          <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                  [value]="_fromCountryCode">
            {{ _fromCountryCode }}
          </option>
        </select>
      </div>

      <!-- Select option for Business Use Case Options -->
      <div class="pure-control-group">
        <label for="businessUseCase">Business Use Case  <app-popover [message]="help_messages.business_unit"></app-popover></label>
        <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase" #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
          <ng-template ngFor let-item [ngForOf]="getItems">
            <optgroup label="{{item.name}}">
              <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
                {{usecase.text}}
              </option>
            </optgroup>
          </ng-template>
        </select>
      </div>

      <!-- Read only text for displaying onboarded component key placeholder-->
      <label for="componentKeyPlaceholderId">Level Of Data  <app-popover [message]="help_messages.level_of_data"></app-popover></label>
      <input id="componentKeyPlaceholderId" class="pure-input-2-3" type="text"
             formControlName="componentKeyPlaceholder" readonly/>

      <!-- Dynamic entries for Component Key Place holder parts -->
      <form [formGroup]="changeTransitTimeActiveVersionForm.get('componentKeyValue')">
        <div *ngFor="let field of currentComponentKeyPlaceholder;let i = index">
          <label for="{{'componentKeyValue'+i}}">{{field}}</label>
          <select type="text" [formControlName]="field" class="pure-input-2-3" id="{{'componentKeyValue'+i}}">
            <option *ngFor="let option of dropDownOptions[field]" [value]="option">
              {{option}}
            </option>
          </select>
        </div>
      </form>

      <!-- Select option for Transit Time Type-->
      <label for="transitTimeTypeId">Select Transit Time Type <app-popover [message]="help_messages.transit_time_type"></app-popover></label>
      <select formControlName="transitTimeType" id="transitTimeTypeId" class="pure-input-2-3">
        <option *ngFor=" let _transitTime of transitTimeOptions; let i = index " [value]="_transitTime">
          {{ _transitTime }}
        </option>
      </select>

      <!-- Get data Buttons-->
      <div>
        <button class="pure-button pure-button-primary button-large" type="submit"
                [disabled]="changeTransitTimeActiveVersionForm.invalid">
          Submit
        </button>
      </div>
    </form>

    <div *ngIf="dataVersions.length != 0 && !loading && hasPermission">
      <table class="pure-table pure-table-horizontal">
        <thead>
        <tr>
          <th>Business Use Case</th>
          <th>From Country Code</th>
          <th>Level Of Data</th>
          <th>Transit Time Type</th>
          <th>File Version</th>
          <th>Creation Time(UTC)</th>
          <th>File Status</th>
          <th>Difference Report</th>
          <th>Lane Count Report</th>
          <th>Uploaded File</th>
          <th>Transit Time File</th>
<!--          <th>Action</th>-->
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let _row of dataVersions">
          <td>
            {{_row.businessUseCase != null ? _row.businessUseCase : "N/A"}}
          </td>
          <td>
            {{_row.fromCountryCode != null ? _row.fromCountryCode : "N/A"}}
          </td>
          <td>
            {{_row.componentKeyValue != null ? _row.componentKeyValue : "N/A"}}
          </td>
          <td>
            {{ _row.transitTimeType != null ? _row.transitTimeType : "N/A"}}
          </td>
          <td>
            {{ _row.fileVersion != null ? _row.fileVersion : "N/A"}}
          </td>
          <td>
            {{ _row.fileVersion != null ? this.commonUtils.convertToDate(_row.fileVersion) : "N/A"}}
          </td>
          <td>
            <div class="colorbox" [style.color]="'ForestGreen'" *ngIf="_row.status == null">
              N/A
            </div>
            <div class="colorbox" [style.color]="'ForestGreen'" *ngIf="_row.status != null && _row.status == 'Active'">
              {{_row.status}}
            </div>
            <div class="colorbox" [style.color]="'Crimson'" *ngIf="_row.status != null && _row.status == 'Inactive'">
              {{_row.status}}
            </div>
            <div class="colorbox" [style.color]="'Orange'"
                 *ngIf="_row.status != null && _row.status == 'Active but unpublished'">
              {{_row.status}}
            </div>
          </td>
          <td>
            <div *ngIf="_row.differenceReportUrl!= null">
              <a target="_blank" href="{{_row.differenceReportUrl}}">
                Difference Report URL
              </a>
            </div>
            <div *ngIf="_row.differenceReportUrl == null">
              N/A
            </div>
          </td>
          <td>
            <div *ngIf="_row.laneCountReportUrl!= null">
              <a target="_blank" href="{{_row.laneCountReportUrl}}">
                Lane Count Report URL
              </a>
            </div>
            <div *ngIf="_row.laneCountReportUrl == null">
              N/A
            </div>
          </td>
          <td>
            <div *ngIf="_row.uploadedFileUrl!= null">
              <a target="_blank" href="{{_row.uploadedFileUrl}}">
                Uploaded File URL
              </a>
            </div>
            <div *ngIf="_row.uploadedFileUrl == null">
              N/A
            </div>
          </td>
          <td>
            <div *ngIf="_row.transitTimeFileUrl!= null">
              <a target="_blank" href="{{_row.transitTimeFileUrl}}">
                Transit Time URL
              </a>
            </div>
            <div *ngIf="_row.transitTimeFileUrl == null">
              N/A
            </div>
          </td>
<!--          <td>-->
<!--            &lt;!&ndash; Get data Buttons&ndash;&gt;-->
<!--            <div *ngIf="_row.status != null && _row.status != 'Active' && _row.status != 'Active but unpublished'"-->
<!--                 class="pure-button-group" role="group"-->
<!--                 aria-label="...">-->
<!--              <button class="button-success pure-button" (click)="activateTransitTimeVersion(_row)" type="button">-->
<!--                Activate-->
<!--              </button>-->
<!--            </div>-->

<!--            <div *ngIf="_row.status == null || _row.status == 'Active' || _row.status == 'Active but unpublished'">-->
<!--              No action-->
<!--            </div>-->

<!--          </td>-->
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Display message when the table is empty -->
    <div *ngIf="dataVersions.length == 0 && !loading && !firstLoad && hasPermission">
      <h2>There are no data versions.</h2>
    </div>

    <app-loader [loading]="loading" [size]="'small'"></app-loader>
  </div>

</div>
